import { trimAndToLowerCase } from "./DocumentSign.conv";
import { DocumentSignerReq, DocumentSignerStatus } from "./DocumentSign.dto";
import { DocumentSignerInternalRequest } from "./DocumentSign.internal.dto";
import { LoLang } from "../common/common.types";

export function ReadableDocumentSignerStatus(status: DocumentSignerStatus, lang?: LoLang | undefined, defaultVal = "-"): string {
  switch (status) {
    case DocumentSignerStatus.None:
    case DocumentSignerStatus.Wait:
      return lang === "KO" ? "서명 대기" : "Wait for Signing";
    case DocumentSignerStatus.Delivering:
      return lang === "KO" ? "문서 전송 중" : "Document Delivering";
    case DocumentSignerStatus.DeliveringFailed:
      return lang === "KO" ? "문서 전송 실패" : "Failed Delivery Document";
    case DocumentSignerStatus.Delivered:
    case DocumentSignerStatus.DeliveringSkipped:
      return lang === "KO" ? "서명 요청" : "Requested";
    case DocumentSignerStatus.Opened:
      return lang === "KO" ? "서명 진행 중" : "In Progress";
    case DocumentSignerStatus.Signed:
      return lang === "KO" ? "서명 완료" : "Signed";
    case DocumentSignerStatus.Declined:
      return lang === "KO" ? "서명 거부" : "Declined";
    default:
      return status || defaultVal;
  }
}

export function findDuplicateSignerEmails(signers: Array<DocumentSignerReq | DocumentSignerInternalRequest>): Array<string> {
  const emailFreqCountMap = new Map<string, number>();

  for (const idx in signers) {
    const signer = signers[Number(idx)];
    const email = trimAndToLowerCase(signer.email);

    if (!email) continue;

    emailFreqCountMap.set(email, (emailFreqCountMap.get(email) || 0) + 1);
  }

  return Array.from(emailFreqCountMap.entries())
    .filter(([, count]) => count > 1)
    .map(([email]) => email);
}
